import type { TrainerConflictDto } from '@/api/admin'

/** Label for one entry in a trainer's conflict/unavailability list — used everywhere
 * TrainerAssignmentFields' conflictMap is built from adminApi.getTrainerConflicts(). */
export function formatTrainerConflict(c: TrainerConflictDto): string {
  return c.kind === 'Unavailable'
    ? `Unavailable${c.reason ? `: ${c.reason}` : ''}`
    : `${c.clientName} — ${c.courseName}`
}
